export class UserData{
    FirstName: string = '';
    LastName: string = '';
    FullName: string = '';
    Email:string='' ;
    access: string = "";
    password:string = "";
    age: string = '';
    progGoalId: string = '';
    program_id: string ='';

    weightGoal: Number = 0;
    activityGoal: Number = 0;
    stepsGoal: Number = 0;
    activitycaloriesGoal: Number = 0;
    foodcaloriesGoal: Number = 0;

    height: string = "";
    riskScore: string = "";
    gender: Number = 0;
    race: Number = 0;
    coachID: string = "";

    // isDone
    isLifestyleDone: boolean = false;
    isAdmin: boolean = false;
    isFirstCheckList: boolean = false;
    isFoodQuizDone: boolean = false;
    isCoach: boolean = false;

    aCode: string= "";
    phone_number="";
    
}